// @flow
import React from 'react';
import './Headliner.less';

type Props = {
    headline: string
};

export default function Headliner({headline}: Props) {
    return (
        <header>
            {/* Keep h1 tag for SEO purposes */}
            <h1 className="Headline__headline">{headline}</h1>
        </header>
    );
}
